// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/global_app_settings_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { AppStatus } from '../../settings/v1/app_status_pb';
import { file_settings_v1_app_status } from '../../settings/v1/app_status_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/global_app_settings_response.proto.
 */
export const file_responses_v1_global_app_settings_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ci9yZXNwb25zZXMvdjEvZ2xvYmFsX2FwcF9zZXR0aW5nc19yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIj8KEUdsb2JhbEFwcFNldHRpbmdzEioKCmFwcF9zdGF0dXMYASABKA4yFi5zZXR0aW5ncy52MS5BcHBTdGF0dXNCiQEKEGNvbS5yZXNwb25zZXMudjFCHkdsb2JhbEFwcFNldHRpbmdzUmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z',
        [file_settings_v1_app_status]
    );

/**
 * @generated from message responses.v1.GlobalAppSettings
 */
export type GlobalAppSettings = Message<'responses.v1.GlobalAppSettings'> & {
    /**
     * @generated from field: settings.v1.AppStatus app_status = 1;
     */
    appStatus: AppStatus;
};

/**
 * Describes the message responses.v1.GlobalAppSettings.
 * Use `create(GlobalAppSettingsSchema)` to create a new message.
 */
export const GlobalAppSettingsSchema: GenMessage<GlobalAppSettings> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_global_app_settings_response, 0);
